import LocationOnRounded from '@mui/icons-material/LocationOnRounded';
import { Box, IconButton, SxProps, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { AssignmentStatus, Workflow } from '@apiContract';
import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';

interface ILocationIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
}

const LocationIcon: FC<ILocationIconProps> = ({ onClick, capturePiece }) => {
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;

  const isLockerNotAssigned =
    piece?.workflow === Workflow.Lockers && piece?.pieceSummary?.pieceAssignmentStatus !== AssignmentStatus.Assigned;

  const disabled = !piece || isLockerNotAssigned;

  return (
    <Tooltip title={tooltips[isLockerNotAssigned ? 'LockerNotAssigned' : 'LocationOnRounded']} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltips.LocationOnRounded}
          sx={{ ...CommonStyles, ...sxMR0 } as SxProps}
        >
          <LocationOnRounded sx={StyledIcon(disabled ? 'action.disabled' : undefined)} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { LocationIcon };
